import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../assets/css/error.scss";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

function NotFoundPage() {
  return (
    <div className="not-found-container">
      <div id="container">
        <div id="wrapper">
          <div id="header">
            <FontAwesomeIcon icon={faExclamationTriangle} className="ifa" />
          </div>
          <div id="content">
            <p>잘못된 주소를 입력하였습니다.</p>
            <p>주소를 확인해 주세요.</p>
            <p>Please Check Your Address.</p>
          </div>
          <div id="footer">
            <div id="footer">
              <p>ⓒ 2025 WEGO & DONGA EASY EDU. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
